import { PostHogProvider } from '@posthog/react'
import posthog from 'posthog-js'
import ReactDOM from 'react-dom/client'
import { Provider as ReduxStoreProvider } from 'react-redux'

import { EEnvironments } from '@/constants/environments'

import './index.css'
import App from './App'
import env from './env/env'
import { store } from './store/store'

/**
 * ----------------------------------------------------------------------------
 * Posthog analytics initialization
 * ----------------------------------------------------------------------------
 * @see https://posthog.com/docs/libraries/react
 */

const POSTHOG_DEFAULT_VERSION = '2025-11-30'

posthog.init(env.PUBLIC_POSTHOG_KEY, {
  api_host: env.PUBLIC_POSTHOG_HOST,
  defaults: POSTHOG_DEFAULT_VERSION,
  debug: false, //env.NODE_ENV !== EEnvironments.Production,

  // Disable automatic pageview capture - we use manual tracking for SPA
  capture_pageview: false,

  loaded: (posthog) => {
    // If the environment is not production, register the environment
    // to filter the events in Posthog.
    if (env.NODE_ENV !== EEnvironments.Production) {
      posthog.register({
        environment: env.NODE_ENV,
      })
    }
  },
})

/**
 * ----------------------------------------------------------------------------
 * SEO: Prevent search engine indexing on non-production environments
 * ----------------------------------------------------------------------------
 */
if (env.NODE_ENV !== EEnvironments.Production) {
  const noIndexMeta = document.createElement('meta')
  noIndexMeta.name = 'robots'
  noIndexMeta.content = 'noindex, nofollow'
  document.head.appendChild(noIndexMeta)
}

/**
 * ----------------------------------------------------------------------------
 * React Root Render
 * ----------------------------------------------------------------------------
 */

const root = ReactDOM.createRoot(document.getElementById('root')!)

root.render(
  <ReduxStoreProvider store={store}>
    <PostHogProvider client={posthog}>
      <App />
    </PostHogProvider>
  </ReduxStoreProvider>,
)
